export default __webpack_public_path__ + "static/media/4 Vrindhavan Jewels.9373cd0b.PNG";